// -----------------------------
// Types
// -----------------------------

export interface ClassSections {
  schedule: string;
  groupSize: string;
  paymentUrl: string;
  faqUrl: string;
}

export interface ClassMeta {
  name: string;
  slug: string;
  dayType: "3-day" | "5-day";
  imageUrl: string;
  shortDescription: string;
  pricing: string;
  sections: ClassSections;

  displayName?: string;
  aliases?: string[];
  listInDropdown?: boolean;

  servicePrefix?: string;
  serviceSeparator?: string;
  bookingChannel?: string;

  durationLabels?: {
    all?: string;
    "0"?: string;
    "1"?: string;
  };
}

// NEW: Suite type
export interface SuiteMeta {
  name: string;
  slug: string;
  roomType: true;
  images: string[];
  shortDescription: string;
  pricing: string;
  sections: ClassSections;
}

// -----------------------------
// Import the generated JSON
// -----------------------------

import rawCatalog from "./utils/classCatalog.json";

// -----------------------------
// Split into classes and suites
// -----------------------------

export const CLASS_CATALOG: ClassMeta[] = rawCatalog.filter(
  (c: any) => !c.roomType
) as ClassMeta[];

export const SUITE_CATALOG: SuiteMeta[] = rawCatalog.filter(
  (c: any) => c.roomType
) as SuiteMeta[];

// -----------------------------
// Lookup maps
// -----------------------------

export const CLASS_BY_NAME: Record<string, ClassMeta> = Object.fromEntries(
  CLASS_CATALOG.map((c) => [c.name, c])
);

export const SUITE_BY_NAME: Record<string, SuiteMeta> = Object.fromEntries(
  SUITE_CATALOG.map((s) => [s.name, s])
);

export const CLASS_BY_SLUG: Record<string, ClassMeta> = Object.fromEntries(
  CLASS_CATALOG.map((c) => [c.slug, c])
);

export const SUITE_BY_SLUG: Record<string, SuiteMeta> = Object.fromEntries(
  SUITE_CATALOG.map((s) => [s.slug, s])
);

// -----------------------------
// Helpers
// -----------------------------

export const getClassesByDayType = (dayType: "3-day" | "5-day") =>
  CLASS_CATALOG.filter((c) => c.dayType === dayType);

export const getAllClassNames = () => CLASS_CATALOG.map((c) => c.name);

export const findClass = (identifier: string): ClassMeta | undefined =>
  CLASS_BY_SLUG[identifier] || CLASS_BY_NAME[identifier];

export const findSuite = (identifier: string): SuiteMeta | undefined =>
  SUITE_BY_SLUG[identifier] || SUITE_BY_NAME[identifier];